export function getNotificationFrequencyValue({ enabled }) {
  return enabled ? 'Daily' : 'Off'
}
